import { render, staticRenderFns } from "./user-vip-update.vue?vue&type=template&id=551b8728"
import script from "./user-vip-update.vue?vue&type=script&lang=js"
export * from "./user-vip-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports